import { render } from "./SolicitudGafete.vue?vue&type=template&id=1d563d70"
import script from "./SolicitudGafete.vue?vue&type=script&lang=js"
export * from "./SolicitudGafete.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__